import { ConfigurationTemplate } from "@/model/data/security/ConfigurationTemplate";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetImportableTemplateResData extends ApiGenericResponse {
    importableTemplates: Array<ConfigurationTemplate>;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ImportableTemplates) {
            this.importableTemplates = new Array();
            obj.ImportableTemplates.forEach((element) => {
                let template = new ConfigurationTemplate();
                template.parse(element);
                this.importableTemplates.push(template);
            });
        }
    }
}
